module.exports = __webpack_public_path__ + "static/media/chess-queen-alt.aabb9648.svg";